import { Component } from 'react';

class AuthScreen extends Component {
  render() {
  	return null
  }
}

export default AuthScreen
